import React from "react";
import { MdRefresh, MdSystemUpdateAlt } from "react-icons/md";
import useAppUpdate from "hooks/useAppUpdate";

export default function AppUpdatePrompt({ defer = false }) {
  const { updateAvailable, refresh, dismiss } = useAppUpdate();
  if (!updateAvailable || defer) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 z-[190] mx-auto max-w-xl rounded-2xl border border-orange-200 bg-white p-4 shadow-2xl dark:border-orange-800 dark:bg-navy-800 sm:bottom-6" role="status" aria-live="polite">
      <div className="flex items-start gap-3">
        <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-[#FFF0EB] text-[#FC6D3F]"><MdSystemUpdateAlt className="h-6 w-6" aria-hidden="true" /></span>
        <div className="min-w-0 flex-1">
          <p className="font-extrabold text-navy-700 dark:text-white">Nouvelle version disponible</p>
          <p className="mt-1 text-sm text-gray-700 dark:text-gray-200">Actualisez pour profiter des dernières améliorations Livresto.</p>
        </div>
      </div>
      <div className="mt-4 flex justify-end gap-2">
        <button type="button" className="cursor-pointer rounded-xl px-4 py-2 text-sm font-bold text-gray-700 transition-colors hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#FC6D3F] dark:text-gray-200 dark:hover:bg-navy-700" onClick={dismiss}>Plus tard</button>
        <button type="button" className="flex cursor-pointer items-center gap-2 rounded-xl bg-[#FC6D3F] px-4 py-2 text-sm font-extrabold text-white transition-colors hover:bg-[#E9562D] focus:outline-none focus:ring-4 focus:ring-orange-200" onClick={refresh}><MdRefresh className="h-5 w-5" aria-hidden="true" /> Actualiser</button>
      </div>
    </div>
  );
}
